const en_whs_itemout = {
    "": "item out",
}

export default en_whs_itemout;